import { useNavigate } from 'react-router-dom';
import { TopBar } from 'components';
import {
  Box, Button, Typography, Paper,
} from '@mui/material';
import StorageIcon from '@mui/icons-material/Storage';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';

export function Admin() {
  const navigate = useNavigate();

  const menuItems = [
    {
      title: 'Gerenciar Dados',
      description: 'Importar/Exportar dados, backups locais',
      icon: <StorageIcon sx={{ fontSize: 48 }} />,
      route: '/update-store',
      color: 'primary',
    },
    {
      title: 'Admin Jogadores',
      description: 'Configurações dos jogadores',
      icon: <AdminPanelSettingsIcon sx={{ fontSize: 48 }} />,
      route: '/players-admin',
      color: 'secondary',
    },
    {
      title: 'Ranking',
      description: 'Ver ranking de jogadores',
      icon: <LeaderboardIcon sx={{ fontSize: 48 }} />,
      route: '/players-ranking',
      color: 'success',
    },
  ];

  return (
    <Box sx={{ bgcolor: '#fdd8e4', minHeight: '100vh' }}>
      <TopBar />
      <Box
        sx={{
          p: 3,
          maxWidth: 800,
          margin: '0 auto',
        }}
      >
        <Typography variant="h4" gutterBottom textAlign="center" sx={{ mb: 4 }}>
          Área Administrativa
        </Typography>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
          }}
        >
          {menuItems.map((item) => (
            <Paper
              key={item.title}
              elevation={3}
              sx={{
                p: 3,
                cursor: 'pointer',
                transition: 'transform 0.2s, box-shadow 0.2s',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: 6,
                },
              }}
              onClick={() => navigate(item.route)}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 3,
                }}
              >
                <Box sx={{ color: `${item.color}.main` }}>
                  {item.icon}
                </Box>
                <Box>
                  <Typography variant="h6">{item.title}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    {item.description}
                  </Typography>
                </Box>
                <Button
                  variant="contained"
                  color={item.color}
                  sx={{ ml: 'auto' }}
                >
                  Acessar
                </Button>
              </Box>
            </Paper>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
